import { List } from 'immutable'

export function isFreeTrialFirstSegment (segments) {
  if (!List.isList(segments)) {
    return false
  }

  const firstSegmentPrice = segments.getIn([0, 'price'])
  return firstSegmentPrice === 0 || firstSegmentPrice === '0'
}

export function isIneligibleFreeTrialBin (issuerBin, binList) {
  if (issuerBin === undefined || issuerBin === null) {
    return false
  }

  const mappedBinList = (binList || []).map((bin) => String(bin))
  return mappedBinList.includes(String(issuerBin).slice(0, 6))
}

export function shouldOpenIneligibleFreeTrialBinModal ({
  issuerBin,
  binList,
  segments,
  isAlreadyOpen,
  enabled,
} = {}) {
  if (enabled !== true) {
    return false
  }

  if (isAlreadyOpen === true) {
    return false
  }

  return isIneligibleFreeTrialBin(issuerBin, binList)
    && isFreeTrialFirstSegment(segments)
}
